export interface RecipeIngredientFoodCandidate {
  archived_at?: string | null;
  recipe_id?: string | null;
}

export function isPreparationFood(food: RecipeIngredientFoodCandidate | null | undefined): boolean {
  return typeof food?.recipe_id === 'string' && food.recipe_id.trim().length > 0;
}

export function selectRecipeIngredientFoods<T extends RecipeIngredientFoodCandidate>(
  foods: readonly T[],
): T[] {
  return foods.filter((food) => !food.archived_at && !isPreparationFood(food));
}
